<template>
    <b-row class="text-left">
        <b-col md="6">

            <b-form-select v-model="selectedCourseId" :options="courseOptions" @input="onCourseChange" size="sm">
            </b-form-select>

        </b-col>
        <b-col md="6">

            <b-form-select v-model="selectedPointId" :options="pointOptions" @input="onPointChange" size="sm">
            </b-form-select>

        </b-col>
    </b-row>
</template>

<script>
export default {
    data() {
        return {
            courses: [],
            points: [],
        }
    },
    computed: {
        courseOptions() {
            return [
                { value: null, text: 'Sélectionner une course', disabled: false },
                ...this.courses.map(course => ({
                    value: course.id,
                    text: course.nom
                }))
            ];
        },
        pointOptions() {
            return [
                { value: null, text: 'Sélectionner un point', disabled: false },
                ...this.points.map(point => ({
                    value: point.id,
                    text: point.nom
                }))
            ];
        },
        selectedCourseId: {
            get() {
                return this.$store.getters['pcCoursePassages/selectedCourse'];
            },
            set(value) {
                // Cette méthode sera appelée par v-model mais on utilise @change à la place
            }
        },
        selectedPointId: {
            get() {
                return this.$store.getters['pcCoursePassages/selectedPoint'];
            },
            set(value) {
                // Cette méthode sera appelée par v-model mais on utilise @change à la place
            }
        }
    },
    methods: {
        initCourses() {
            const courses = this.$store.state.parcours.list;
            this.courses = courses.map(course => ({
                id: course.id,
                nom: course.nom,
            }));
            this.courses = this.courses.filter(course => course.id !== null);
        },
        initPoints() {
            for (const course of this.$store.state.parcours.list) {
                const points = course.list_points.map(point => ({
                    id: point.id,
                    nom: point.nom,
                    prefix: point.prefix,
                }));
                this.points.push(...points);
                //remove duplicates
                this.points = this.points.filter((point, index, self) =>
                    index === self.findIndex((t) => t.prefix === point.prefix)
                );

            }
            // ajouté le point "Arrivée"
            this.points.push({
                id: "arrivee",
                nom: "Arrivée",
                prefix: "Arrivée",
            });
        },
        onCourseChange(courseId) {
            if (courseId === null) return;
            const course = this.courses.find(c => c.id === courseId);
            if (course) {
                this.selectCourse(course);
            }
        },
        onPointChange(pointId) {
            if (pointId === null) return;
            const point = this.points.find(p => p.id === pointId);
            if (point) {
                this.selectPoint(point);
            }
        },
        selectCourse(course) {
            this.$store.commit("pcCoursePassages/setSelectedCourse", course);
            this.$store.dispatch("pcCoursePassages/fetchCoursesPassages");
        },
        selectPoint(point) {
            this.$store.commit("pcCoursePassages/setSelectedPoint", point);
            this.$store.dispatch("pcCoursePassages/fetchPointsPassages");
        }
    },
    mounted() {
        this.initCourses();
        this.initPoints();
    }

}
</script>

<style lang="scss"></style>